module.exports = __webpack_public_path__ + "static/media/icon-cupones-autoservicio.8007a9ae.svg";